<!--
  ~ Copyright 2022. NXGN Management, LLC. All Rights Reserved.
  -->

<div class="offset-md-3" [formGroup]="parentGroup">
  <fieldset>
    <div class="form-group">
      <label class="col-md-4 control-label" for="merchantTagLine">
        Merchant Tagline
      </label>
      <div class="col-md-8">
        <input
          class="form-control"
          type="text"
          formControlName="merchantTagLine"
          [ngClass]="{
            'is-invalid':
              statementFormControls.merchantTagLine.invalid &&
              (statementFormControls.merchantTagLine.dirty ||
                statementFormControls.merchantTagLine.touched)
          }"
          id="merchantTagLine"
        />
        <div
          *ngIf="
            statementFormControls.merchantTagLine.invalid &&
            (statementFormControls.merchantTagLine.dirty ||
              statementFormControls.merchantTagLine.touched)
          "
        >
          <div
            class="text-danger"
            *ngIf="statementFormControls.merchantTagLine.errors?.maxlength"
          >
            Content is too long. Please shorten it
          </div>
        </div>
      </div>
    </div>

    <div class="form-group">
      <label class="col-md-4 control-label" for="merchantLogo">
        Statement Logo
      </label>
      <div class="col-md-8">
        <div class="form-group">
          <img id="merchantLogo" [src]="logoImage" />
        </div>

        <div class="form-group">
          <span class="btn btn-primary" (click)="openLogoUploadDialog()">
            <span class="fa fa-upload"></span>
            Upload new Logo Image
          </span>
        </div>
      </div>
    </div>

    <div class="form-group">
      <label class="col-md-4 control-label" for="merchantLogoFilename">
        Statement Logo Name
      </label>
      <div class="col-md-8">
        <input
          class="form-control"
          type="text"
          formControlName="merchantLogoFilename"
          id="merchantLogoFilename"
        />
      </div>
    </div>

    <div class="form-group">
      <label class="col-md-4 control-label" for="payOrBillByPhoneNumber">
        Pay By Phone Number
      </label>
      <div class="col-md-8">
        <input
          class="form-control"
          type="number"
          formControlName="payOrBillByPhoneNumber"
          [ngClass]="{
            'is-invalid':
              statementFormControls.payOrBillByPhoneNumber.invalid &&
              (statementFormControls.payOrBillByPhoneNumber.dirty ||
                statementFormControls.payOrBillByPhoneNumber.touched)
          }"
          id="payOrBillByPhoneNumber"
        />
        <div
          *ngIf="
            statementFormControls.payOrBillByPhoneNumber.invalid &&
            (statementFormControls.payOrBillByPhoneNumber.dirty ||
              statementFormControls.payOrBillByPhoneNumber.touched)
          "
        >
          <div
            class="text-danger"
            *ngIf="statementFormControls.payOrBillByPhoneNumber.errors?.pattern"
          >
            Must be 10 digits.
          </div>
        </div>
      </div>
    </div>

    <div class="form-group">
      <label class="col-md-4 control-label" for="payOrBillByPhoneHours">
        Pay By Phone Hours
      </label>
      <div class="col-md-8">
        <input
          class="form-control"
          type="text"
          formControlName="payOrBillByPhoneHours"
          [ngClass]="{
            'is-invalid':
              statementFormControls.payOrBillByPhoneHours.invalid &&
              (statementFormControls.payOrBillByPhoneHours.dirty ||
                statementFormControls.payOrBillByPhoneHours.touched)
          }"
          id="payOrBillByPhoneHours"
        />
        <div
          *ngIf="
            statementFormControls.payOrBillByPhoneHours.invalid &&
            (statementFormControls.payOrBillByPhoneHours.dirty ||
              statementFormControls.payOrBillByPhoneHours.touched)
          "
        >
          <div
            class="text-danger"
            *ngIf="
              statementFormControls.payOrBillByPhoneHours.errors?.maxlength
            "
          >
            Content is too long. Please shorten it.
          </div>
        </div>
      </div>
    </div>

    <div class="form-group">
      <label class="col-md-4 control-label" for="billQueryNumber">
        Bill Query Phone Number
      </label>
      <div class="col-md-8">
        <input
          class="form-control"
          type="number"
          formControlName="billQueryNumber"
          [ngClass]="{
            'is-invalid':
              statementFormControls.billQueryNumber.invalid &&
              (statementFormControls.billQueryNumber.dirty ||
                statementFormControls.billQueryNumber.touched)
          }"
          id="billQueryNumber"
        />
        <div
          *ngIf="
            statementFormControls.billQueryNumber.invalid &&
            (statementFormControls.billQueryNumber.dirty ||
              statementFormControls.billQueryNumber.touched)
          "
        >
          <div
            class="text-danger"
            *ngIf="statementFormControls.billQueryNumber.errors?.pattern"
          >
            Must be 10 digits.
          </div>
        </div>
      </div>
    </div>

    <div class="form-group">
      <label class="col-md-4 control-label" for="payOrBillBillQueryHours">
        Bill Query Hours
      </label>
      <div class="col-md-8">
        <input
          class="form-control"
          type="text"
          formControlName="billQueryHours"
          [ngClass]="{
            'is-invalid':
              statementFormControls.billQueryHours.invalid &&
              (statementFormControls.billQueryHours.dirty ||
                statementFormControls.billQueryHours.touched)
          }"
          id="payOrBillBillQueryHours"
        />
        <div
          *ngIf="
            statementFormControls.billQueryHours.invalid &&
            (statementFormControls.billQueryHours.dirty ||
              statementFormControls.billQueryHours.touched)
          "
        >
          <div
            class="text-danger"
            *ngIf="statementFormControls.billQueryHours.errors?.maxlength"
          >
            Content is too long. Please shorten it.
          </div>
        </div>
      </div>
    </div>

    <div class="form-group">
      <label class="col-md-4 control-label" for="stmtDueDateLeadDays">
        Days between Statement Date and Due Date
      </label>
      <div class="col-md-8">
        <input
          class="form-control"
          type="number"
          formControlName="stmtDueDateLeadDays"
          [ngClass]="{
            'is-invalid':
              statementFormControls.stmtDueDateLeadDays.invalid &&
              (statementFormControls.stmtDueDateLeadDays.dirty ||
                statementFormControls.stmtDueDateLeadDays.touched)
          }"
          id="stmtDueDateLeadDays"
        />
      </div>
      <div
        *ngIf="
          statementFormControls.stmtDueDateLeadDays.invalid &&
          (statementFormControls.stmtDueDateLeadDays.dirty ||
            statementFormControls.stmtDueDateLeadDays.touched)
        "
      >
        <div
          class="text-danger"
          *ngIf="statementFormControls.stmtDueDateLeadDays.errors?.max"
        >
          Number can not be higher than 60.
        </div>
      </div>
    </div>

    <div class="col-md-6">
      <div class="form-group mb-4">
        <div class="custom-control form-control-md custom-checkbox">
          <input
            class="custom-control-input"
            type="checkbox"
            formControlName="statementTestMode"
            id="statementTestMode"
          />
          <label
            class="custom-control-label bold-label"
            for="statementTestMode"
          >
            Enable Statement Test Mode
          </label>
        </div>
      </div>

      <div class="form-group mb-4">
        <div class="custom-control form-control-md custom-checkbox">
          <input
            class="custom-control-input"
            type="checkbox"
            formControlName="displayAgingBoxes"
            id="displayAgingBoxes"
            (change)="updateInsuranceAgingCheckbox()"
          />

          <label
            class="custom-control-label bold-label"
            for="displayAgingBoxes"
          >
            Display Aging Boxes
          </label>
        </div>
      </div>

      <div class="form-group mb-4">
        <div class="custom-control form-control-md custom-checkbox">
          <input
            class="custom-control-input"
            type="checkbox"
            formControlName="displayInsuranceAgingBoxes"
            id="displayInsuranceAgingBoxes"
          />
          <label
            class="custom-control-label bold-label"
            for="displayInsuranceAgingBoxes"
          >
            Display Insurance Aging Boxes
          </label>
        </div>
      </div>

      <div class="form-group mb-4">
        <div class="custom-control form-control-md custom-checkbox">
          <input
            class="custom-control-input"
            type="checkbox"
            formControlName="displayStatementDetail"
            id="displayStatementDetail"
          />
          <label
            class="custom-control-label bold-label"
            for="displayStatementDetail"
          >
            Display Details
          </label>
        </div>
      </div>

      <div class="form-group mb-4">
        <div class="custom-control form-control-md custom-checkbox">
          <input
            class="custom-control-input"
            type="checkbox"
            formControlName="payOrBillByCheck"
            id="payOrBillByCheck"
            (change)="updateReturnByMailCheckbox()"
          />
          <label class="custom-control-label bold-label" for="payOrBillByCheck">
            Pay By Check
          </label>
        </div>
      </div>

      <div class="form-group mb-4">
        <div class="custom-control form-control-md custom-checkbox">
          <input
            class="custom-control-input"
            type="checkbox"
            formControlName="payOrBillByMoneyOrder"
            id="payOrBillByMoneyOrder"
            (change)="updateReturnByMailCheckbox()"
          />
          <label
            class="custom-control-label bold-label"
            for="payOrBillByMoneyOrder"
          >
            Pay By Money Order
          </label>
        </div>
      </div>

      <div class="form-group mb-4">
        <div class="custom-control form-control-md custom-checkbox">
          <input
            class="custom-control-input checkbox-aligned"
            type="checkbox"
            formControlName="displayDetachReturnByMail"
            id="displayDetachReturnByMail"
          />
          <label
            class="custom-control-label bold-label"
            for="displayDetachReturnByMail"
          >
            Display Detach Return By Mail
          </label>
          <div
            class="formValidationMessage"
            role="alert"
            *ngIf="
              statementFormControls.displayDetachReturnByMail.dirty ||
              statementFormControls.displayDetachReturnByMail.touched
            "
          >
            <div
              *ngIf="
                statementFormControls.displayDetachReturnByMail.errors
                  ?.noRemitAddress
              "
            >
              Merchant Remit-to address must be filled in!
            </div>
          </div>
        </div>
      </div>

      <div class="form-group mb-4">
        <div class="custom-control form-control-md custom-checkbox">
          <input
            class="custom-control-input"
            type="checkbox"
            formControlName="displayMerchantName"
            id="displayMerchantName"
          />
          <label
            class="custom-control-label bold-label"
            for="displayMerchantName"
          >
            Display Merchant Name
          </label>
        </div>
      </div>
    </div>
  </fieldset>
</div>
